import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RequirementPriorityOption } from '../models/requirement.model';

export interface CountByPriorityResponse {
  priority: string;
  count: number;
}

@Injectable({ providedIn: 'root' })
export class RequirementPriorityService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<RequirementPriorityOption[]> {
    return this.http.get<RequirementPriorityOption[]>(this.liste(projectId));
  }

  create(projectId: string, value: string): Observable<RequirementPriorityOption> {
    return this.http.post<RequirementPriorityOption>(this.liste(projectId), { value });
  }

  rename(projectId: string, id: string, value: string): Observable<RequirementPriorityOption> {
    return this.http.put<RequirementPriorityOption>(`${this.liste(projectId)}/${id}`, { value });
  }

  reorder(projectId: string, orderedIds: string[]): Observable<void> {
    return this.http.patch<void>(`${this.liste(projectId)}/reorder`, { orderedIds });
  }

  delete(projectId: string, id: string, moveTo?: string): Observable<void> {
    const params = moveTo ? new HttpParams().set('moveTo', moveTo) : undefined;
    return this.http.delete<void>(`${this.liste(projectId)}/${id}`, { params });
  }

  countByPriority(projectId: string, priority: string): Observable<CountByPriorityResponse> {
    const params = new HttpParams().set('priority', priority);
    return this.http.get<CountByPriorityResponse>(`${this.base}/${projectId}/requirements/count-by-priority`, {
      params,
    });
  }

  private liste(projectId: string): string {
    return `${this.base}/${projectId}/requirement-priorities`;
  }
}
